import React, { useRef } from "react";
import style from '../../styles/countryadmissionsday.module.scss';
import styles from '../../styles/applicationweek.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { sliderSpeed } from "../../utils/constants";

interface Props {
    toprankdata: any;
}

const Toprankeduniversity: React.FC<Props> = ({ toprankdata }) => {
    const sliderRef = useRef<Slider>(null);
    const settings = {
        infinite: true,
        arrows: false,
        speed: sliderSpeed.desktopSpeed,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 3,
        slidesPerRow: 4,
        autoplay: true,
        autoplaySpeed: sliderSpeed.desktopAutoplaySpeed,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rows: 3,
                    slidesPerRow: 3,
                    arrows: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rows: 2,
                    slidesPerRow: 2,
                    dots: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rows: 2,
                    slidesPerRow: 2,
                    dots: true,
                    autoplaySpeed: sliderSpeed.mobileAutoplaySpeed,
                }
            }
        ]
    };
    


    return (
        <>
            <div className={style.popularcourses} style={{ backgroundColor: toprankdata?.sectionBgColor || "#FFF1EF" }}>
                <div>
                    <Container>
                        <Row>
                            <div className={style.heading}>
                                <h1>{toprankdata?.sectionTitle}</h1>
                                {toprankdata?.sectionDescription && <p>{toprankdata?.sectionDescription}</p>}
                            </div>
                        </Row>
                    </Container>
                    <Container className="sliderComponent">
                        <Row>
                            <div className={styles.popularCourseslider}>
                                <Slider {...settings} className={styles.slider} ref={sliderRef}>
                                    {
                                        toprankdata?.universityImages?.length > 0 &&
                                        toprankdata?.universityImages?.map((universityImage: any, ind: number) => {
                                            return (

                                                <Col xl={6} sm={12} xs={6} key={ind}>
                                                    <div className={styles.mainBox}>
                                                        <div className={styles.box}>
                                                            <div className={styles.img}>
                                                                <CustomImage src={universityImage?.imageUrl || "/images/admissionsday/popularstart.png"} width={223} height={88} className={styles.studImg} alt={universityImage?.imageAltTag} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            )
                                        })
                                    }
                                </Slider>
                                {
                                     toprankdata?.universityImages?.length> 12 && (
                                        <div className={style.arrowsClass}>
                                        <div className={style.btcircle} onClick={() => sliderRef?.current?.slickPrev()}>
                                            <CustomImage src='/new-images/left-arrow.svg' height={17} width={10} alt={"left-arrow"} />
                                        </div>
                                        <div className={style.btcircle} onClick={() => sliderRef?.current?.slickNext()}>
                                            <CustomImage src='/new-images/right-arrow.svg' height={17} width={10} alt={"right-arrow"} />
                                        </div>
                                    </div>
                                     )
                        
                                }
                               
                            </div>
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    )
}
export default Toprankeduniversity;